type InstanceStatusSource = {
  status?: unknown
  display_status?: unknown
}

const verifyResizeDisplayStatuses = new Set(['Підтвердьте зміну розміру'])

const normalizeStatus = (status: unknown): string => {
  if (typeof status !== 'string') {
    return ''
  }

  return status
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
}

export const isVerifyResizeInstanceStatus = (instance?: InstanceStatusSource | null): boolean => {
  if (!instance) {
    return false
  }

  if (typeof instance.display_status === 'string' && verifyResizeDisplayStatuses.has(instance.display_status)) {
    return true
  }

  return [instance.status, instance.display_status].some((status) => {
    const normalizedStatus = normalizeStatus(status)

    return normalizedStatus === 'verify_resize' || normalizedStatus === 'resized'
  })
}
